// src/v2/pages/Reports/ReportRF1.js
import React from 'react';
import { GeneralMessage } from '../../../common/APICommon';
import { useReportRF1 } from '../../hooks/useReportRF1';
import { ReportRF1Module } from '../../components/modules/Reports/ReportRF1/ReportRF1Module';

const ReportRF1 = ({ isHideSideMenu }) => {
  const reportHook = useReportRF1();

  return (
    <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
      <div className="LeftSpace"></div>
      <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
        <ReportRF1Module reportHook={reportHook} />
      </div>
      <GeneralMessage form={reportHook.showMessage} message={reportHook.message} isSuccess={reportHook.isSuccess} />
    </div>
  );
};

export default ReportRF1;